import type { AssistantState } from '../services/assistantService'
import type { AssistantInputType } from './chatWidgetUtils'

export function inferAssistantInputType(
  state?: AssistantState,
  uiInputType?: AssistantInputType,
  replyText?: string,
  hasAvailableDeviceChoices: boolean = true
): AssistantInputType {
  const normalizedReply = replyText?.toLowerCase() ?? ''

  const indicatesNoDevicesAvailable =
    normalizedReply.includes('ei ole saatavilla laitteita') ||
    normalizedReply.includes('ei saatavilla laitteita') ||
    (normalizedReply.includes('lisää laite ensin projektiin') &&
      !normalizedReply.includes('valitse laite alla olevasta listasta'))

  if (indicatesNoDevicesAvailable) {
    return 'text'
  }

  if (
    uiInputType === 'project_select' ||
    uiInputType === 'device_select' ||
    uiInputType === 'tag_select' ||
    uiInputType === 'confirm'
  ) {
    if (
      state?.workflow === 'device_install' &&
      state?.step === 'ask_device' &&
      (state?.deviceType === 'SPINE' || state?.deviceType === 'VALVE') &&
      uiInputType === 'device_select'
    ) {
      return 'text'
    }

    return uiInputType
  }

  if (state?.step === 'ask_project') {
    return 'project_select'
  }

  if (state?.step === 'ask_device') {
    if (
      state?.workflow === 'device_install' &&
      (state?.deviceType === 'SPINE' || state?.deviceType === 'VALVE')
    ) {
      return 'text'
    }

    return 'device_select'
  }

  if (state?.step === 'ask_valve_in_tag_id' || state?.step === 'ask_valve_out_tag_id') {
    return 'tag_select'
  }

  if (state?.step === 'ask_tag_id') {
    return 'tag_select'
  }

  if (state?.step === 'ask_spine_main_distribution') {
    return 'confirm'
  }

  if (
    state?.workflow === 'device_install' &&
    state?.step === 'confirm' &&
    state?.deviceType === 'SPINE'
  ) {
    return 'text'
  }

  const asksConfirmation =
    normalizedReply.includes('onko tämä oikein') ||
    normalizedReply.includes('vahvista asennustiedot') ||
    normalizedReply.includes('vahvista asennus')

  if (asksConfirmation) {
    return 'confirm'
  }

  const asksDeviceSelection =
    normalizedReply.includes('valitse laite') ||
    normalizedReply.includes('asentaa tagin') ||
    (normalizedReply.includes('qr-kood') && normalizedReply.includes('laitekood')) ||
    /ai.?tulkint/i.test(normalizedReply)

  if (asksDeviceSelection) {
    return hasAvailableDeviceChoices ? 'device_select' : 'text'
  }

  if (normalizedReply.includes('valitse projekti')) {
    return 'project_select'
  }

  if (normalizedReply.includes('valitse tagi')) {
    return 'tag_select'
  }

  return 'text'
}
